// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-369494c1] {\n  font-size: 2rem;\n  margin: 2rem 0 1rem;\n}", ""]);
// Exports
module.exports = exports;
